export default "__VITE_ASSET__04335c60__"